'use client';

import { useEffect, useState } from 'react';
import { ErrorState } from '@/components/error/ErrorState';
import {
  captureClientError,
  openUserFeedbackDialog,
  type ErrorCorrelation,
} from '@/lib/observability/client-error-reporting';
import { getStateCopy } from '@/lib/copy/user-facing-messages';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const globalErrorCopy = getStateCopy('globalUnexpectedError');
  const [correlation, setCorrelation] = useState<ErrorCorrelation | null>(null);

  useEffect(() => {
    console.error('Global error:', error);
    setCorrelation(
      captureClientError(error, {
        surface: 'global-error',
        supportCode: error.digest ?? null,
      })
    );
  }, [error]);

  return (
    <html lang="en">
      <body>
        <ErrorState
          error={error}
          eventId={correlation?.eventId ?? undefined}
          homeHref="/"
          homeLabel="Go Home"
          onRetry={reset}
          onReport={
            correlation?.eventId
              ? () => {
                  openUserFeedbackDialog(correlation);
                }
              : undefined
          }
          reportAction={globalErrorCopy.reportAction}
          sectionLabel="this page"
          supportHref="mailto:support@eclipseaccounting.app"
          viewport="screen"
        />
      </body>
    </html>
  );
}
